import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import ResidentialElectrical from "./pages/ResidentialElectrical";
import CommercialElectrical from "./pages/CommercialElectrical";
import ThermalScanning from "./pages/ThermalScanning";
import GeneratorInstallation from "./pages/GeneratorInstallation";
import HighriseTurnovers from "./pages/HighriseTurnovers";
import PanelUpgrades from "./pages/PanelUpgrades";
import Solar from "./pages/Solar";
import EVCharging from "./pages/EVCharging";
import FireAlarm from "./pages/FireAlarm";
import ProjectEstimation from "./pages/ProjectEstimation";
import Contact from "./pages/Contact";
import TermsAndConditions from "./pages/TermsAndConditions";
import Financing from "./pages/Financing";
import Careers from "./pages/Careers";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/residential" element={<ResidentialElectrical />} />
          <Route path="/services/commercial" element={<CommercialElectrical />} />
          <Route path="/services/thermal-scanning" element={<ThermalScanning />} />
          <Route path="/services/generator-installation" element={<GeneratorInstallation />} />
          <Route path="/services/highrise-turnovers" element={<HighriseTurnovers />} />
          <Route path="/services/panel-upgrades" element={<PanelUpgrades />} />
          <Route path="/services/solar" element={<Solar />} />
          <Route path="/services/ev-charging" element={<EVCharging />} />
          <Route path="/services/fire-alarm" element={<FireAlarm />} />
          <Route path="/services/project-estimation" element={<ProjectEstimation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/careers" element={<Careers />} />
          {/* Redirect other service routes to home for now */}
          <Route path="/services/*" element={<Home />} />
          <Route path="/about" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
